import React, { useReducer, cloneElement } from "react";

import classNames from "classnames/bind";

import { QuickFilters } from "../QuickFilters";

import styles from "./Filters.module.scss";

import type { FiltersProps } from "./types";

import Panel from "../Panel/Panel";

const cx = classNames.bind(styles);

/**
 * @deprecated use "FilterPanel" instead (see Storybook documentation)
 */
export const Filters = ({
  quickFilters,
  filters,
  actions,
  onChange,
}: FiltersProps) => {
  const updateFilterState = (state: any, newValues: Record<string, any>) => {
    const newValue = {
      ...state,
      ...newValues,
    };

    onChange(newValue);

    return newValue;
  };

  const [filterState, setFilterState] = useReducer(updateFilterState, {
    ...(filters
      ? filters?.reduce(
          (total, { name, value }) => ({
            ...total,
            [name]: value,
          }),
          {}
        )
      : {}),
    ...(quickFilters ? { quickFilters: undefined } : {}),
  });

  return (
    <Panel className={cx("container")}>
      {quickFilters ? (
        <div className={cx("topContainer")}>
          <div className={cx("quickFiltersContainer")}>
            <QuickFilters
              value={filterState.quickFilters}
              {...quickFilters}
              onChange={(newValue) => {
                setFilterState({ quickFilters: newValue });
              }}
            />
          </div>
        </div>
      ) : null}

      <div className={cx("bottomContainer")}>
        <div className={cx("filtersContainer")}>
          {filters?.every((filter) => React.isValidElement(filter)) ? (
            <>{filters.map((filter) => filter)}</>
          ) : (
            <>
              {filters?.map(({ name, component, ...restProps }) =>
                cloneElement(component, {
                  ...restProps,
                  value: filterState[name],
                  onChange: (newValue: any) => {
                    setFilterState({ [name]: newValue });
                  },
                })
              )}
            </>
          )}
        </div>

        {actions?.length ? (
          <div className={cx("actionsContainer")}>
            {actions?.length ? (
              <>{actions?.map((action: any) => action)}</>
            ) : null}
          </div>
        ) : null}
      </div>
    </Panel>
  );
};
